(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dod-design-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dod-design-shop'))customElements.define('dod-design-shop',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const cards=[...this.querySelectorAll('.dod-design-card')];
cards.forEach(card=>{
const link=card.querySelector('.dod-design-link');
if(!link)return;
card.defaultImage=link.querySelector('img').getAttribute('src');
card.defaultUrl=link.getAttribute('href');
card.defaultPrice=link.querySelector('.dod-design-price').textContent;
const labels={'hoodie':'Hoodie','sweatshirt':'Sweatshirt','long-sleeve':'Long Sleeve','tee':'T-Shirt','other':'More Gear'};
const used=new Set();
card.querySelectorAll('.dod-garment-choice').forEach(choice=>{
if(used.has(choice.dataset.garment))return;
used.add(choice.dataset.garment);
const button=document.createElement('button');
button.type='button';
button.textContent=labels[choice.dataset.garment];
button.dataset.cardStyle=choice.dataset.garment;
button.setAttribute('aria-pressed',String(choice.getAttribute('href')===card.defaultUrl));
button.addEventListener('click',()=>{
const image=link.querySelector('img');
image.setAttribute('src',choice.dataset.image);
image.removeAttribute('srcset');
link.setAttribute('href',choice.getAttribute('href'));
link.querySelector('.dod-design-price').textContent=choice.dataset.price;
card.querySelectorAll('[data-card-style]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
});
card.querySelector('.dod-card-styles').append(button);
});
});
this.querySelectorAll('[data-style]').forEach(button=>button.addEventListener('click',()=>{
const style=button.dataset.style;
this.querySelectorAll('[data-style]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
let visible=0;
cards.forEach(card=>{
if(card.classList.contains('dod-single-card')){
card.hidden=style!=='all'&&card.dataset.garment!==style;
}else{
const choices=[...card.querySelectorAll('.dod-garment-choice')];
const chosen=choices.find(a=>a.dataset.garment===style);
card.hidden=style!=='all'&&!chosen;
const link=card.querySelector('.dod-design-link');
const image=link.querySelector('img');
image.setAttribute('src',style==='all'?card.defaultImage:chosen?.dataset.image||card.defaultImage);
image.removeAttribute('srcset');
link.setAttribute('href',style==='all'?card.defaultUrl:chosen?.getAttribute('href')||card.defaultUrl);
link.querySelector('.dod-design-price').textContent=style==='all'?card.defaultPrice:chosen?.dataset.price||card.defaultPrice;
card.querySelectorAll('[data-card-style]').forEach(b=>b.setAttribute('aria-pressed',String(style==='all'?choices.find(a=>a.getAttribute('href')===card.defaultUrl)?.dataset.garment===b.dataset.cardStyle:b.dataset.cardStyle===style)));
}
if(!card.hidden)visible++;
});
this.querySelector('.dod-design-empty').hidden=visible>0;
}));
this.querySelector('.dod-design-empty').hidden=cards.length>0;
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dod-mm-rail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dod-product-rail')) customElements.define('dod-product-rail', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const rail = this.querySelector('.mm-rail');
    const pool = [...this.querySelector('.mm-rail-pool').content.querySelectorAll('.mm-product')];
    const random = this.dataset.random === 'true';
    const shuffle = a => {
      if (random) for (let i=a.length-1;i>0;i--) {
        const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];
      }
      return a;
    };
    const classify = node => {
      const s = (node.dataset.kind + ' ' + (node.querySelector('h3')?.textContent || '')).toLowerCase();
      if (/hoodie|hooded/.test(s)) return 'hoodie';
      if (/sweatshirt|crewneck|crew neck|sweater/.test(s)) return 'sweatshirt';
      if (/long[ -]?sleeve/.test(s)) return 'long';
      if (/t[ -]?shirt|\btee\b|short[ -]?sleeve/.test(s)) return 'tee';
      return 'other';
    };
    const kinds = ['hoodie','sweatshirt','long','tee'];
    const buckets = Object.fromEntries([...kinds,'other'].map(k=>[k,[]]));
    const seen = new Set();
    shuffle(pool).forEach(node => {
      if (seen.has(node.dataset.productId)) return;
      seen.add(node.dataset.productId);
      buckets[classify(node)].push(node);
    });
    Object.values(buckets).forEach(shuffle);
    const count = Math.min(Number(this.dataset.limit)||100,100);
    const chosen=[], selected=new Set();
    const take = kind => {
      const queue=buckets[kind];
      while (queue.length) {
        const n=queue.shift();
        if (!selected.has(n.dataset.productId)) return n;
      }
      return null;
    };
    for(let i=0;i<count;i++){
      let node=take(kinds[i%4]);
      if(!node){
        // Never show a duplicate; gracefully fill gaps if a garment type is missing.
        for(const kind of shuffle([...kinds,'other'])){
          node=take(kind);
          if(node)break;
        }
      }
      if(!node)break;
      selected.add(node.dataset.productId);
      chosen.push(node);
    }
    if(!chosen.length) return;
    // Fill all configured slots if the selected collections contain fewer unique items.
    // Unique products are always used first; only then are repeats introduced.
    const uniqueCount=chosen.length;
    for(let i=uniqueCount;i<count;i++) chosen.push(chosen[i%uniqueCount].cloneNode(true));
    // Three identical sequences allow seamless cycling in either direction.
    const makeSet = () => chosen.map(n=>n.cloneNode(true));
    rail.replaceChildren(...makeSet(),...chosen,...makeSet());
    const size=chosen.length;
    const getSpan=()=>rail.children[size]?.offsetLeft-rail.children[0]?.offsetLeft || 0;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    let moving=false, span=0;
    const reposition=(logical=0)=>{
      span=getSpan();
      rail.scrollLeft=span+logical;
    };
    const keepLoop=()=>{
      if(moving||!span)return;
      const x=rail.scrollLeft;
      if(x<span*0.5 || x>span*1.5){
        moving=true;
        rail.style.scrollSnapType='none';
        rail.scrollLeft=x+(x<span*0.5?span:-span);
        requestAnimationFrame(()=>{rail.style.scrollSnapType='';moving=false;});
      }
    };
    const initialize=()=>{span=getSpan();if(span)reposition(0)};
    requestAnimationFrame(initialize);
    const page=()=> {
      const cards=window.innerWidth>=750?4:2;
      const first=rail.children[0], second=rail.children[1];
      const stride=second&&first ? second.offsetLeft-first.offsetLeft : rail.clientWidth/cards;
      return stride*cards;
    };
    const move=dir=>{
      keepLoop();
      rail.scrollBy({left:dir*page(),behavior:reduced?'instant':'smooth'});
    };
    this.querySelector('.mm-prev').addEventListener('click',()=>move(-1));
    this.querySelector('.mm-next').addEventListener('click',()=>move(1));
    let raf=0;
    rail.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(keepLoop)},{passive:true});
    this.observer=new ResizeObserver(()=>{
      const old=span, relative=old?((rail.scrollLeft-old)%old+old)%old:0;
      reposition(relative);
    });
    this.observer.observe(rail);
  }
  disconnectedCallback(){this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dod-mm-spotlight"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dod-spotlight')) customElements.define('dod-spotlight',class extends HTMLElement {
  connectedCallback(){if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('.mm-slide')];this.dots=[...this.querySelectorAll('[data-slide]')];this.pauseButton=this.querySelector('[data-pause]');this.reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;this.paused=this.dataset.autoplay!=='true'||this.reduced;this.index=this.dataset.random==='true'&&!window.Shopify?.designMode?Math.floor(Math.random()*this.slides.length):0;this.show(this.index);this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel);this.dots.forEach((b,i)=>b.addEventListener('click',()=>{this.show(i);this.restart()}));this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel);this.restart()});this.addEventListener('mouseenter',()=>this.stop());this.addEventListener('mouseleave',()=>this.restart());this.addEventListener('focusin',()=>this.stop());this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))this.restart()});this.onVisibility=()=>document.hidden?this.stop():this.restart();document.addEventListener('visibilitychange',this.onVisibility);this.onBlock=e=>{const i=this.slides.findIndex(s=>s.dataset.block===e.detail.blockId);if(i>=0){this.show(i);this.stop()}};document.addEventListener('shopify:block:select',this.onBlock);let x=0;this.addEventListener('touchstart',e=>x=e.changedTouches[0].clientX,{passive:true});this.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-x;if(Math.abs(delta)>45){this.show(this.index+(delta<0?1:-1));this.restart()}},{passive:true});this.restart()}
  show(i){if(!this.slides.length)return;this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>{s.hidden=n!==this.index;s.classList.toggle('is-active',n===this.index)});this.dots.forEach((b,n)=>{b.classList.toggle('is-active',n===this.index);n===this.index?b.setAttribute('aria-current','true'):b.removeAttribute('aria-current')})}
  stop(){clearInterval(this.timer)}
  restart(){this.stop();if(!this.paused&&!document.hidden&&!this.matches(':focus-within')&&this.slides.length>1)this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)*1000)}
  disconnectedCallback(){this.stop();document.removeEventListener('visibilitychange',this.onVisibility);document.removeEventListener('shopify:block:select',this.onBlock)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
